"use client"

import { Subscription } from "@/app/types/Subscription"
import { PricingCard } from "./pricing-card"
import type { Plan, PricingPlanItem } from "./types"

interface PricingPlansGridProps {
    plans: Plan[]
    currentSubscription?: Subscription
    pricing: PricingPlanItem[]
    isYearly: boolean
    loadingPlan: string | null
    publicMode?: boolean
    discountApplied?: boolean
    onPlanSelect: (plan: Plan) => void
}

export function PricingPlansGrid({
    plans,
    currentSubscription,
    pricing,
    isYearly,
    loadingPlan,
    publicMode,
    discountApplied,
    onPlanSelect,
}: PricingPlansGridProps) {
    return (
        <section className="flex flex-col w-full sm:flex-row sm:flex-wrap justify-center gap-4 mt-8">
            {plans.map((plan) => {
                const planWithCurrent = {
                    ...plan,
                    isCurrent: plan.type === currentSubscription?.planType,
                    actionLabel: plan.type === currentSubscription?.planType ? "Current Plan" : plan.actionLabel,
                } as Plan

                return (
                    <PricingCard
                        key={plan.title}
                        plan={planWithCurrent}
                        isYearly={isYearly}
                        onPlanSelect={() => onPlanSelect(plan)}
                        currentSubscription={currentSubscription}
                        pricing={pricing}
                        isLoading={loadingPlan === plan.title}
                        publicMode={publicMode}
                        discountApplied={discountApplied}
                    />
                )
            })}
        </section>
    )
}
